module.exports = __webpack_public_path__ + "static/media/me_wedding_compressed.ec669a36.jpg";